import { render, staticRenderFns } from "./RestrictedAccessPolicy.vue?vue&type=template&id=a90b72ce&"
import script from "./RestrictedAccessPolicy.vue?vue&type=script&lang=ts&"
export * from "./RestrictedAccessPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports